import React, { useState, useEffect } from "react";
import { Row, Col, Card, Modal, Select, Table, Button, Spin } from "antd";
import { base_url } from "../../utils/apiConfig";
import newStyled from "@emotion/styled";
import axios from "axios";
import "../../styles/StoreInsights.css";
import { useTenantContext } from "../../utils/Context/TenantsContext";
import { useFetchQueTypes } from "../../utils/hooks/UseFetchUrl";

const StoreInsights = () => {
  const [selectedQueId, setSelectedQueId] = useState(null);
  const [detailsData, setDetailsData] = useState([]);
  const [cycleId, setCycleId] = useState(null);
  const [selectedKeyword, setSelectedKeyword] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [keywordsData, setKeywordsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedReportData, setSelectedReportData] = useState([]);
  const [keywordMapping, setKeywordMapping] = useState({});
  const [cyclesData, setCyclesData] = useState([]);
  const [hasFetchedKeywords, setHasFetchedKeywords] = useState(false);
  const { data: queTypesData } = useFetchQueTypes("/questionnaire_types_for_dashboard");
  const queId = queTypesData?.[0]?.id;
  const tenant = useTenantContext()

  useEffect(() => {
    if (!selectedQueId && queId) {
      setSelectedQueId(null);
    }
  }, [queId, selectedQueId]);

  useEffect(() => {
    const fetchCycles = async () => {
      if (selectedQueId) {
        try {
          const authToken = localStorage.getItem("authToken");
          const response = await axios.get(
            `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/questionnaire_types_list/${selectedQueId}/audit_cycle`,
            {
              headers: {
                Authorization: `token ${authToken}`,
                "Content-Type": "application/json",
              },
            }
          );
          setCyclesData(response.data);
          setDetailsData(response.data);
          setCycleId(null);
        } catch (error) {
          console.error("Error fetching Type of Audit:", error);
        }
      }
    };

    fetchCycles();
  }, [selectedQueId]);

  useEffect(() => {
    if (cyclesData) {
      setDetailsData(cyclesData);
      setCycleId(null);
    }
  }, [cyclesData]);

  const handleSelectChange = (value) => {
    const selectedId = parseInt(value, 10);
    setSelectedQueId(selectedId);
    setHasFetchedKeywords(false);
    setKeywordsData([]);
    setCycleId(null);
  };

  const handleSelectChange1 = async (event) => {
    const selectedId1 = parseInt(event.target.value, 10);
    setCycleId(selectedId1);
    setHasFetchedKeywords(true);
    setLoading(true);
    try {
      const authToken = localStorage.getItem("authToken");
      const response = await axios.get(
        `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/report/questionnaire_type/${selectedQueId}/audit_cycle/${selectedId1}/keyword_analysis`,
        {
          headers: {
            Authorization: `token ${authToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      const data = response.data;
      const positiveKeywords = data.total_positive_keywords || [];
      const negativeKeywords = data.total_negative_keywords || [];
      const keywordMappingData = data.keyword_source_mapping || {};
      const formattedKeywords = [
        ...Object.keys(positiveKeywords).map((key) => ({
          title: key,
          value: positiveKeywords[key],
          percentage: data.positive_keywords_percentage[key] || "N/A",
          type: "positive",
        })),
        ...Object.keys(negativeKeywords).map((key) => ({
          title: key,
          value: negativeKeywords[key],
          percentage: data.negative_keywords_percentage[key] || "N/A",
          type: "negative",
        })),
      ];

      const shuffledKeywords = formattedKeywords.sort(
        () => Math.random() - 0.5
      );

      setKeywordsData(shuffledKeywords);
      setKeywordMapping(keywordMappingData);
      console.log("Shuffled Keywords Data:", shuffledKeywords);
    } catch (error) {
      console.error("Error fetching keyword analysis data:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCardClick = (item) => {
    const reportIds = keywordMapping[item.title] || [];

    const formattedReportIds = reportIds.map((reportId, index) => ({
      key: `${item.title}-${index}`,
      srNo: index + 1,
      keyword: item.title,
      reportId: reportId,
    }));

    setSelectedKeyword(item);
    setSelectedReportData(formattedReportIds);
    setIsModalVisible(true);
  };
  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  const columns = [
    {
      title: "Sr No",
      dataIndex: "srNo",
      key: "srNo",
      align: "center",
      className: "sr-no-column",
    },
    {
      title: "Keyword",
      dataIndex: "keyword",
      key: "keyword",
      width: 150,
      align: "center",
    },
    {
      title: "Report ID",
      dataIndex: "reportId",
      key: "reportId",
      width: 120,
      align: "center",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <ButtonStyle
          type="primary"
          onClick={() =>
            window.open(`/auditReport/${record.reportId}`, "_blank")
          }
        >
          View
        </ButtonStyle>
      ),
    },
  ];
  return (
    <div style={{ minHeight: "500px" }}>
      <div className="AtHeroSection">
        <div className="storeParaAiHead">
          <p className="my-3">Ai Keyword Wise Analysis</p>
        </div>
        <div className="step-ai">Step 1: Select the Questionnaire Type → Step 2: Select the Type of Audit </div>
        <div className="step-ai">After completing the steps above, you will be able to view concreted KeyWord AI Analysis for Audit Cycle.</div>
        <div className="head-si d-flex align-items-center justify-content-between flex-nowrap mt-3">

          <div className="d-flex align-items-center gap-2 flex-nowrap">
            <div className="d-flex align-items-center gap-2">
              <p className="SiQuesHeading">Questionnaire Type:</p>
              <SelectStyle
                value={selectedQueId || undefined}
                onChange={handleSelectChange}
                placeholder="Please Select Questionnaire"
                className="at-select"
                style={{ width: 200 }}
              >
                {queTypesData?.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </SelectStyle>
            </div>
            <div className="d-flex align-items-center gap-2">
              <p className="SiQuesHeading">Type of Audit:</p>

              <SelectStyle
                value={cycleId || undefined}
                onChange={(value) => handleSelectChange1({ target: { value } })}
                placeholder="Please Select Type of Audit"
                className="auditCycleAT"
                style={{ width: 200 }}
              >
                {detailsData?.length > 0 ? (
                  detailsData.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))
                ) : (
                  <Select.Option disabled>No data available</Select.Option>
                )}
              </SelectStyle>
            </div>
          </div>
        </div>
        {/* <div className="grid-container">
          {!cyclesData || cyclesData.length === 0 ? (
            <div className="image-container">
              {loading ? (
                <div>
                  <Spin size="medium" />
                </div>
              ) : (
                <>
                  <img
                    src={bgImage}
                    alt="Select Questionnaire"
                    style={{
                      width: "100%",
                      maxHeight: "400px",
                      objectFit: "contain",
                      opacity: "0.2",
                    }}
                  />
                  <p
                    style={{
                      textAlign: "center",
                      marginTop: "10px",
                      fontSize: "18px",
                      fontWeight: "bold",
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      color: "#333",
                    }}
                  >
                    Please select qestionnaire and Type of Audit
                  </p>
                </>
              )}
            </div>
          ) : (
            <Row gutter={[16, 16]} justify="center" align="middle">
              {keywordsData?.length > 0 ? (
                keywordsData.map((item, index) => {
                  const span = Math.max(
                    4,
                    Math.min(8, Math.floor(24 * (item.value / 10)))
                  );
                  return (
                    <Col key={index} span={span} className="keyword-col">
                      <StyledCard
                        type={item.type}
                        onClick={() => handleCardClick(item)}
                      >
                        {item.title} <br /> ({item.value}) <br />
                        {item.percentage ? `${item.percentage}%` : "N/A"}
                      </StyledCard>
                    </Col>
                  );
                })
              ) : (
                <div className="image-container">
                  <img
                    src={bgImage}
                    alt="Select Questionnaire"
                    style={{
                      width: "100%",
                      maxHeight: "400px",
                      objectFit: "contain",
                      opacity: "0.2",
                    }}
                  />
                  <p
                    style={{
                      textAlign: "center",
                      marginTop: "10px",
                      fontSize: "18px",
                      fontWeight: "bold",
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      color: "#333",
                    }}
                  >
                    Please select qestionnaire and Type of Audit
                  </p>
                </div>
              )}
            </Row>
          )}
        </div> */}
        <div className="grid-container">
          {!selectedQueId || !cycleId ? (
            // Nothing selected yet
            <div className="image-container">
              <img
                src={tenant?.storeInsightsBgImg}
                alt="Select Questionnaire"
                style={{
                  width: "100%",
                  maxHeight: "400px",
                  objectFit: "contain",
                  opacity: "0.2",
                }}
              />
              <p
                style={{
                  textAlign: "center",
                  marginTop: "10px",
                  fontSize: "18px",
                  fontWeight: "bold",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: "#333",
                }}
              >
                Please select questionnaire and Type of Audit
              </p>
            </div>
          ) : loading ? (
            // Fetching data
            <div style={{ display: "flex", justifyContent: "center", padding: "3rem" }}>
              <Spin size="large" />
            </div>
          ) : hasFetchedKeywords && keywordsData.length === 0 ? (
            // Fetched but no data found
            <div className="image-container">
              <img
                src={tenant?.storeInsightsBgImg}
                alt="Select Questionnaire"
                style={{
                  width: "100%",
                  maxHeight: "400px",
                  objectFit: "contain",
                  opacity: "0.2",
                }}
              />
              <p
                style={{
                  textAlign: "center",
                  marginTop: "10px",
                  fontSize: "18px",
                  fontWeight: "bold",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: "#333",
                }}
              >
                No keyword data available for this selection.
              </p>
            </div>
          ) : (
            // Data available, show cards
            <Row gutter={[16, 16]} justify="center" align="middle">
              {keywordsData.map((item, index) => {
                const span = Math.max(
                  4,
                  Math.min(8, Math.floor(24 * (item.value / 10)))
                );
                return (
                  <Col key={index} span={span} className="keyword-col">
                    <StyledCard
                      type={item.type}
                      onClick={() => handleCardClick(item)}
                    >
                      {item.title} <br /> ({item.value}) <br />
                      {item.percentage ? `${item.percentage}%` : "N/A"}
                    </StyledCard>
                  </Col>
                );
              })}
            </Row>
          )}
        </div>
      </div>
      {isModalVisible && selectedKeyword && (
        <Modal
          title={
            <span className="custom-modal-title">Keyword Analysis Report</span>
          }
          open={isModalVisible}
          onCancel={handleCloseModal}
          footer={null}
          width={600}
        >
          <TableStyleModal
            dataSource={selectedReportData}
            columns={columns}
            pagination={false}
          />
        </Modal>
      )}
    </div>
  );
};

const StyledCard = newStyled(Card)`

  background-color: ${(props) =>
    props.type === "positive" ? "#74c69d" : "#e88e92"};
  color: ${(props) => (props.type === "positive" ? "#155724" : "#721c24")};
  padding: 16px;
  text-align: center;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    background-color: ${(props) =>
    props.type === "positive" ? "#469d89" : "#f67269"};
  color: ${(props) => (props.type === "positive" ? "#ffffff" : "#000000")};

  }
`;

const ButtonStyle = newStyled(Button)`
:where(.css-dev-only-do-not-override-1kf000u).ant-btn-variant-solid {
    background-color: #007DC1 !important;
}

:where(.css-dev-only-do-not-override-1kf000u).ant-btn-variant-solid {
    color: #fff;
    background: #1677ff;
}
:where(.css-dev-only-do-not-override-1kf000u).ant-btn-color-primary {
    color: #ffffff;
    // box-shadow: 0 2px 0 rgba(5, 145, 255, 0.1);
}
:where(.css-dev-only-do-not-override-1kf000u).ant-btn {
padding: 1rem !important;
margin:0.5rem 0rem !important;
  }
`;
const TableStyleModal = newStyled(Table)`
margin-top: 1rem !important;

.ant-table .ant-table-cell:first-child {
  width: 80px !important;
  min-width: 80px !important;
  max-width: 80px !important;
}
  .ant-table thead th:nth-child(4), 
.ant-table tbody td:nth-child(4) {
      width: 80px !important;
    min-width: 80px !important;
    max-width: 80px !important;
    padding:0.5rem 0rem !important;
}

 .ant-table tbody tr:nth-child(odd) {
    background-color: #ffffff !important;
  }
  
  .ant-table tbody tr:nth-child(even) {
    background-color:rgb(242,242,242) !important;
    transition: background-color 0.3s ease;
  }
  
  .ant-table tbody tr:nth-child(odd):hover {
    background-color: rgb(242,242,242) !important;
  }
  .ant-table tbody tr:nth-child(odd):hover td {
    background-color:  rgb(242,242,242) !important;
  }
  
  .ant-table tbody tr:nth-child(even):hover {
    background-color: rgb(242,242,242) !important;
  }
  
  .ant-table tbody tr:nth-child(even):hover td {
    background-color:  rgb(242,242,242) !important;
  }
  
  .ant-table tbody tr {
    transition: background-color 0.3s ease;
  }

  :where(.css-1kf000u).ant-table-wrapper .ant-table-cell, :where(.css-1kf000u).ant-table-wrapper .ant-table-thead>tr>th{
  padding: 4px 16px !important;
  }
`;
const SelectStyle = newStyled(Select)`
  :where(.css-dev-only-do-not-override-1kf000u).ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {
  border-bottom: 1.75px solid #000 !important;
  border-top: 0px solid #fff !important;
  border-right: 0px solid #fff !important;
  border-left: 0px solid #fff !important;
  border-radius: 1px !important;
  // border:none !important;
  }

  :where(.css-1kf000u).ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {
  border-bottom: 1.75px solid #000 !important;
  border-top: 0px solid #fff !important;
  border-right: 0px solid #fff !important;
  border-left: 0px solid #fff !important;
  border-radius: 1px !important;
  
  }


`;
export default StoreInsights;
